// English
export const locale = {
  global: {
    create: 'Create',
    ok: 'Ok',
    previous: 'Previous',
    nextStep: 'Next Step',
    createDate: 'Create Date',
    category: 'Category',
    hello: 'Hello',
    languageSelection: 'Language Selection',
    language: 'Language',
    search: 'Search',
    addNew: 'Add New',
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    noData: 'No data',
    loadingItems: 'Loading items...',
    copied: 'Copied',
    select: 'Select',
    clear: 'Clear',
    actions: 'Actions',
    events: 'Events',
    notifications: 'Notifications',
    makeRead: 'Make read',
    deleteAll: 'Delete all',
    noNotificationToDisplay: 'No notification to display.',
    informations: 'Informations',
    pleaseSelect: 'Please select',
    features: 'Features',
    isActive: 'Is Active?',
    name: 'Name',
    surname: 'Surname',
    type: 'Type',
    totalDisk: 'Total Disk',
    totalDiskMB: 'Total Disk (MB)',
    userDisk: 'User Disk',
    userDiskMB: 'User Disk (MB)',
    isReadonly: 'Is Readonly?',
    diskPhysicalType: 'Disk Physical Type',
    diskType: 'Disk Type',
    size: 'Size',
    sizeMb: 'Size (MB)',
    isAttached: 'Is Attached?',
    yes: 'Yes',
    no: 'No',
    ipAddress: 'IP Address',
    version: 'Version',
    os: 'OS',
    perGB: 'Per GB',
    services: 'Services',
    networking: 'Networking',
    serviceName: 'Service Name',
    isPublic: 'Is Public?',
    country: 'Country',
    city: 'City',
    manage: 'Manage',
    roleUpdated: 'Role Updated!',
    successful: 'Your transaction has been completed successfully!',
    createVirtualMachineSuccessful:
      'Your transaction has been completed successfully, The Virtual Machine will be created shortly.',
    anErrorHasOccurred:
      'An error occurred, please try again later or contact your administrator.!',
    destinationIp: 'Destination Ip',
    destinationPort: 'Destination Port',
    price: 'Price',
    pricePerGb: 'Price (Per GB)',
    contractPrice: 'Contract Price',
    selectedDiskSize: 'Selected disk size',
    roleRemoved: 'Role Removed!',
    remove: 'Remove',
    pleaseConfirm: 'Please Confirm',
    doYouWantToContinueProcessing: 'Do you want to continue processing?',
    areYouSure: 'Are you sure? There is no going back!',
    areYouSureBlank: 'Are you sure?',
    solveQuestion:
      'To complete the process, solve the following process and press the confirm button',
    confirm: 'Confirm',
    confirmed: 'Confirmed',
    whatIsTheSum: 'what is the sum of {0}?',
    writeTheAnswer: 'Write the answer',
    detail: 'Detail',
    success: 'Success',
    error: 'Error',
    isAvaible: 'Is Avaible ?',
    device: 'Device',
    update: 'Update',
    execute: 'Execute',
    unknown: 'Unknown',
    public: 'Public',
    private: 'Private',
    hostname: 'Hostname',
    cpuCores: 'CPU Cores',
    ram: 'Ram',
    ramMB: 'Ram (MB)',
    usedCpu: 'Used CPU',
    usedRam: 'Used RAM',
    usedDisk: 'Used Disk',
    usedDiskMB: 'Used Disk (MB)',
    isAlive: 'Is Alive?',
    vlan: 'VLAN',
    subnet: 'Subnet',
    changeName: 'Change Name',
    tagPool: 'Tag Pool',
    auto: 'Auto',
    minutes: '{0} Minutes',
    hours: '{0} Hours',
    days: '{0} Days',
    hourlyPrice: 'Hourly Price',
    subdomain: 'Subdomain',
    status: 'Status',
    openDetail: 'Open Detail',
    continues: 'Continues',
    selectProductCatalogList: 'Select Product Catalog List',
    selectFromList: 'Select From List',
    month: '{0} Month',
    year: '{0} Year',
    doYouWantToDelete: 'Do you want to delete?',
    delete: 'Delete',
    description: 'Description',
    general: 'General',
    list: 'List',
    and: 'and',
    send: 'Send',
    advanced: 'Advanced',
    lock: 'Lock',
    connectedTo: 'Connected to',
    state: 'State',
    service: 'Service',
    protocol: 'Protocol',
    priority: 'Priority',
    weight: 'Weight',
    port: 'Port',
    target: 'Target',
    refresh: 'Refresh',
    generateStrongPassword: 'Generate strong password',
    stash: 'Stash',
    subscription: 'Subscription',
    currency: 'Currency',
    currencyCode: 'Currency Code',
    value: 'Value',
    maxBandwidth: 'Max Bandwidth',
    cpu: 'CPU',
    hardDisk: 'Hard Disk',
    domain: 'Domain',
    id: 'ID',
    ipSubnet: 'IP / Subnet',
    bandWidthMaxBW: 'Bandwidth / Max BW',
    electricity: 'Electricity',
    generators: 'Generators',
    tierLevel: 'Tier Level',
    isEdge: 'Is Edge',
    configurations: 'Configurations',
    more: 'More',
    createStorageMembers: 'Create Storage Members',
    more: 'More',
    ipV4: 'IP v4',
    ipV6: 'IP v6',
    true: 'True',
    false: 'False',
    username: 'Username',
    password: 'Password',
    newPassword: 'New password',
    passwordConfirmation: 'Password confirmation',
    passwordOperations: 'Password Operations',
    hash: 'Hash',
    cpuType: 'CPU Type',
    extra: 'Extra',
    distro: 'Distro',
    imagesPath: 'Images Path',
    isoPath: 'ISO Path',
    path: 'Path',
    replicas: 'Replicas',
    image: 'Image',
    receivingPort: 'Receiving Port',
    distributingPort: 'Distributing Port',
    enableService: 'Enable Service',
    networkType: 'Network Type',
    gateway: 'Gateway',
    ipAddressRangeStart: 'IP Address Range Start',
    ipAddressRangeEnd: 'IP Address Range End',
    account: 'Account',
    community: 'Community',
    team: 'Team',
    url: 'URL',
    email: 'Email',
    groupName: 'Group Name',
    userpassword: 'User Password',
    member: 'Member',
    enterMemberInfo: 'Enter member information',
    addMember: 'Add Member',
    basic: 'Basic',
    preferences: 'Preferences',
    currentPassword: 'Current Password',
    title: 'Title',
    verificationCode: 'Verification Code',
    location: 'Location',
    page404: 'Page Not Found',
    pageCallback: 'Callback',
    login: 'Login',
  },
  auth: {
    welcome: 'Welcome to Plusclouds',
    newHere: 'New Here?',
    createAnAccount: 'Create an Account',
    loginWith: 'Login with Plusclouds',
    redirectMessage:
      "Please wait, you're being redirected back to the {0} Console.",
    signOut: 'Sign out',
    youNeedToLogInToContinue:
      'You need to log in again to continue your operation.',
  },
  dashboard: {
    dashboard: 'Dashboard',
    followOnYoutube: 'Follow us on Youtube!',
    youtubeInfoLine1:
      'Did you know that you can create new disks on our servers without the need of anyone, manage the disks you host or the services you receive, and perform all these operations with a few clicks?',
    youtubeInfoLine2:
      '"How to login to Leo Panel", "How to set up a virtual machine", "How to create a New Network", "Add a new disk image" and many more <a href="https://www.youtube.com/playlist?list? list=PLsL_qghN-mdGMYtQcUTAvxhQCpRVcebCU" class="font-weight-bold" target="_blank">LEO Panel User Guide</a>.',
    goDNSService: 'Go to DNS Service',
    dnsInfoLine1:
      'Have you tried our <a href="/networking/domain-name-service" class="text-primary opacity-75-hover">DNS Service</a>?',
    dnsInfoLine2:
      'If "What is DNS?" If so, we welcome you to <a href="https://plusclouds.com.tr/blog/dns-nedir" target="_blank" class="text-muted">to our blog</a>.',
    joinUsDiscord: 'Join us On Discord',
    resourceUsage: 'Resource Usage',
    readTheArticle: 'Read The Article',
    goToBlog: 'Go To Blog',
  },
  pagination: {
    goToPage: 'Go to the page',
    totalRecord: 'Total Record',
  },
  filters: {
    filters: 'Filters',
    all: 'All',
    allPriorities: 'All Priorities',
    allCategories: 'All Categories',
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    windows: 'Microsoft® Windows',
    linux: 'Linux',
    allTypes: 'All types',
    running: 'Running',
    halted: 'Halted',
    paused: 'Paused',
    preparing: 'Preparing',
    showAll: 'Show All',
    active: 'Active',
    configuring: 'Configuring',
    inactive: 'Inactive',
    scheduled: 'Scheduled',
    onlyEnabled: 'Only Enabled',
    done: 'Done',
    idDesc: 'Descending by Id',
    idAsc: 'Ascending by Id',
    nameDesc: 'Descending by name',
    nameAsc: 'Ascending by name',
    open: 'Open',
    pending: 'Pending',
    closed: 'Closed',
  },
  servers: {
    servers: 'Servers',
    compute: 'Compute',
    vm: 'Virtual Machines',
    vmDetail: 'Virtual Machine Detail',
    newVM: 'New Virtual Machine',
    searchVM: 'Search for Virtual Machines',
    vd: 'Virtual Disks',
    vdImage: 'Virtual Disks Images',
    plusCloudsCs: 'PlusClouds CS',
    plusCloudsCsDetail: 'PlusClouds CS Detail',
    newVD: 'Create Disk Image',
    newPlusCloudsCs: 'Create PlusClouds CS',
    searchForVD: 'Search for Virtual Disk',
    searchForPlusCloudsCs: 'Search for PlusClouds CS',
    attachedNotFound: 'Attached not found',
    notAttached: 'Not attached',
    attachedTo: 'Attached to:',
    vnc: 'Virtual Network Cards',
    newVNC: 'Create Virtual Network Card',
    searchForVNC: 'Search for Virtual Network Card',
    macAddress: 'Mac Address',
    network: 'Network',
    bandwidth: 'Bandwidth',
    bandwidthMbit: 'Bandwidth (Mbit)',
    ipManagement: 'IP Management',
    newIP: 'Add IP',
    searchForIP: 'Search for IP',
    networkName: 'Network Name',
    templates: 'Templates',
    templateDetail: 'Template Detail',
    newTemplate: 'Create Template',
    searchForTemplate: 'Search for Template',
    templateName: 'Template name',
    selectTemplate: 'Select Template',
    distribution: 'Distribution',
    baseRam: 'Base RAM',
    baseDisk: 'Base Disk',
    baseRamGb: 'Base RAM (GB)',
    baseDiskGb: 'Base Disk (GB)',
    virtualZones: 'Virtual Zones',
    searchForNetworks: 'Search for Networks',
    newNetwork: 'Create Network',
    trafficCost: 'Traffic Cost',
    dnsManagement: 'Domain Name Services Management',
    newDomain: 'Create Domain',
    searchForDomain: 'Search for Domain',
    domainName: 'Domain Name',
    runningUnderService: 'Running Under Service',
    ansible: 'Red Hat® Ansible',
    ansibleDetail: 'Red Hat® Ansible Detail',
    playbooks: 'Playbooks',
    procedures: 'Procedures',
    executionsList: 'Executions List',
    createRedHatAnsiblePlaybook: 'Create Red Hat® Ansible Playbook',
    playbookName: 'Playbook Name',
    roleCount: 'Role Count',
    roleName: 'Role Name',
    lastExecutionTime: 'Last Execution Time',
    executionTotalTime: 'Execution Total Time',
    resultOk: 'Result Ok',
    resultChanged: 'Result Changed',
    resultUnreachable: 'Result Unreachable',
    resultFailed: 'Result Failed',
    resultSkipped: 'Result Skipped',
    resultRescued: 'Result Rescued',
    resultIgnored: 'Result Ignored',
    ok: 'Ok',
    changed: 'Changed',
    unreachable: 'Unreachable',
    failed: 'Failed',
    skipped: 'Skipped',
    rescued: 'Rescued',
    ignored: 'Ignored',
    time: 'Time',
    createProxyRule: 'Create Proxy Rule',
    proxyManagement: 'Proxy Management',
    serverName: 'Server Name',
    sourceIP: 'Source Ip',
    sourcePort: 'Source Port',
    destinationIP: 'Destination Ip',
    destinationPort: 'Destination Port',
    createNatRule: 'Create NAT Rule',
    natManagement: 'NAT (Network Address Translation) Management',
    messageQueuing: 'Message Queuing',
    createMessageQueue: 'Create Message Queue',
    searchForMessageQueuing: 'Search for Message Queuing',
    databaseService: 'Database Service',
    databaseType: 'Database Type',
    databaseVersion: 'Database Version',
    createDatabaseService: 'Create Database Service',
    searchForDatabase: 'Search for Database',
    createCloudNode: 'Create Cloud Node',
    cloudNodes: 'Cloud (Datacenter) Nodes',
    cloudNode: 'Cloud Node',
    cloudNodeDetail: 'Cloud Node Detail',
    storagePoolsDetail: 'Storage Pools Detail',
    datacenter: 'Datacenter',
    cloudVendor: 'Cloud Vendor',
    pricingModel: 'Pricing Model',
    myCloud: 'My Cloud',
    computeManagement: 'Compute Management',
    computeMembers: 'Compute Members',
    computePools: 'Compute Pools',
    searchForComputePools: 'Search for Compute Pools',
    computePoolName: 'Compute Pool Name',
    changePoolPassword: 'Change Pool Password',
    virtualization: 'Virtualization',
    poolType: 'Pool Type',
    storagePools: 'Storage Pools',
    searchForStoragePools: 'Search for Storage Pools',
    networkPools: 'Network Pools',
    searchForNetworkPools: 'Search for Network Pools',
    storage: 'Storage',
    renameDisk: 'Rename disk',
    attachToAServer: 'Attach to a server',
    detachFromServer: 'Detach from server',
    changeDiskSize: 'Change disk size',
    cloneDisk: 'Clone disk',
    terminate: 'Terminate',
    terminateDomain: 'Terminate Domain',
    renameNetworkCard: 'Rename Network Card',
    changeMacAddress: 'Change Mac Address',
    attachIPv4: 'Attach IPv4',
    detachIPv4: 'Detach IPv4',
    assignRandomIP: 'Assign Random IP',
    assignRandomIPv4: 'Assign Random IPv4',
    attachToANetworkCard: 'Attach to a network card',
    detachFromANetworkCard: 'Detach from a network card',
    removeReservation: 'Remove reservation',
    reservation: 'Reservation',
    selectedReservationIP: 'The IP Address you choose will be reserved.',
    disableNATRule: 'Disable NAT Rule',
    enableNATRule: 'Enable NAT Rule',
    deleteNATRule: 'Delete NAT Rule',
    executeOnDevice: 'Execute on device',
    executeOnVirtualMachine: 'Execute on virtual machine',
    renamePlaybook: 'Rename Playbook',
    proxyService: 'Proxy Service',
    natService: 'NAT Service',
    dnsService: 'DNS Service',
    reserveIP: 'Reserve Ip',
    networkCardName: 'Network Card Name',
    enterNetworkCardName: 'Enter network card name',
    enterNetworkName: 'Enter network name',
    convertToTemplate: 'Convert to template',
    updateVMName: 'Update virtual machine name',
    vmName: 'Virtual machine name',
    enterVmName: 'Enter virtual machine name',
    updateHostName: 'Update hostname',
    hostName: 'Hostname',
    enterHostName: 'Enter hostname',
    overrideUsername: 'Override username',
    overridePassword: 'Override password',
    lockDynamicChanges: 'Lock dynamic changes',
    unlockDynamicChanges: 'Unlock dynamic changes',
    takeSnapshot: 'Take Snapshot',
    vmMustBeHalted: 'The virtual machine must be halted for this operation.',
    enterDistribution: 'Enter distribution',
    operatingSystem: 'Operating System',
    enterOperatingSystem: 'Enter operating system',
    distributionVersion: 'Distribution Version',
    enterDistributionVersion: 'Enter distribution version',
    username: 'Username',
    enterUsername: 'Enter username',
    password: 'Password',
    enterPassword: 'Enter password',
    passwordConfirmation: 'Password Confirmation',
    enterPasswordConfirmation: 'Enter password confirmation',
    newPassword: 'New password',
    snapshotName: 'Snapshot Name',
    enterSnapshotName: 'Enter snapshot name',
    snapshotInfo:
      'Taking snapshot uses harddisk space. The price estimation below is calculated from the hour you take snapshot and end of your billing cycle.',
    unlockDynamicInfo:
      'By unlocking this virtual machine you <b>will enable</b> on some actions. For instance;<ul><li>You can change resources</li><li>You can restart this machine</li><li>You can shutdown this machine</li><li>You can unplug this machine</li><li>You can clone this machine</li><li>You can terminate this machine</li></ul>',
    lockDynamicInfo:
      'By locking this virtual machine you <b>will be limited</b> on some actions. For instance;<ul><li>You cannot change resources</li><li>You cannot restart this machine</li><li>You cannot shutdown this machine</li><li>You cannot unplug this machine</li><li>You cannot clone this machine</li><li>You cannot terminate this machine</li></ul>',
    tagServer: 'Tag Server',
    selectTag: 'Select Tag',
    renameNetworkCard: 'Rename network card',
    changeMacAddress: 'Change mac address',
    deviceNumber: 'Device Number',
    randomIPWillBeGenerated: 'Random IP address will be generated.',
    diskName: 'Disk Name',
    enterDiskName: 'Enter disk name',
    changeSizeInfo:
      'You are now changing the disk image size. Please make sure that you increase the disk size internally or add the free space as a new volume.',
    numberOfCores: 'Number of cores',
    memorySize: 'Memory size',
    cpuUpdatedSuccessfully: 'CPU updated successfully.',
    ramUpdatedSuccessfully: 'RAM updated successfully.',
    incomingIP: 'Incoming IP',
    incomingPort: 'Incoming Port',
    outgoingIP: 'Outgoing IP',
    outgoingPort: 'Outgoing Port',
    recordType: 'Record Type',
    record: 'Record',
    recordSubdomain: 'Record / Subdomain',
    content: 'Content',
    contentValue: 'Content / Value',
    updateContent: 'Update content',
    updateTTL: 'Update TTL',
    createAttachNetworkCard: 'Create & Attach Network Card',
    createAttachDiskImages: 'Create & Attach Disk Images',
    attachExistingDiskImages: 'Attach Existing Disk Images',
    selectDisk: 'Select Disk',
    advancedDns: 'Advanced DNS',
    natGateways: 'NAT Gateways',
    proxyGateways: 'Proxy Gateways',
    addRecord: 'Add Record',
    ttl: 'TTL',
    streamName: 'Stream Name',
    streamingDate: 'Streaming Date',
    streaming: 'Streaming',
    streamingDetail: 'Streaming Detail',
    searchForStreams: 'Search for streams',
    createNewStream: 'Create New Stream',
    streamPreview: 'Stream Preview',
    streamInfo:
      'Please publish the stream using publish url and the stream key.',
    addNewPublishLink: 'Add New Publish Link',
    releaseInformation: 'Release Information',
    broadcastQuality: 'Broadcast Quality',
    broadcastStartTime: 'Broadcast Start Time',
    releaseTime: 'Release Time',
    broadcastEndTime: 'Broadcast End Time',
    copyEmbedCode: 'Copy Embed Code',
    streamInformation: 'Stream Informations',
    streamKey: 'Stream Key',
    streamUrl: 'Stream Url',
    streamUrlPlaceholder: 'rtmp://1.1.1.1/LiveApp',
    publishUrl: 'Publish Url',
    publicKey: 'Public Key',
    publishLinks: 'Publish Links',
    serviceType: 'Service Type',
    incomingRouterIp: 'Incoming Router IP',
    streamingClusters: 'Streaming Clusters',
    streamingClustersDetail: 'Streaming Cluster Detail',
    createCluster: 'Create Cluster',
    updateCluster: 'Update Cluster',
    createEdge: 'Create edge',
    updateEdge: 'Update edge',
    createOrigin: 'Create origin',
    updateOrigin: 'Update origin',
    createStream: 'Create Stream',
    updateStream: 'Update Stream',
    broadcastAnalysisInProgress: 'Broadcast analysis in progress...',
    dhcpServerName: 'DHCP Server Name',
    dhcpRecordCount: 'DHCP Record Count',
    dnsServerName: 'DNS Server Name',
    dnsRecordCount: 'DNS Record Count',
    natServerName: 'NAT Server Name',
    natRecordCount: 'NAT Record Count',
    proxyServerName: 'Proxy Server Name',
    proxyRecordCount: 'Proxy Record Count',
    natRules: 'NAT Rules',
    proxyRules: 'Proxy Rules',
    dnsDetail: 'DNS Detail',
    enterComputeMembersForSearch: 'Enter compute members for search',
  },
  detail: {
    goToConsole: 'Go To Console',
    stop: 'Stop',
    start: 'Start',
    restart: 'Restart',
    plugUnplug: 'Unplug & Plug',
    unplug: 'Unplug',
    serverOperations: 'Server Operations',
    tags: 'Tags',
    management: 'Management',
    addTag: 'Add tag..',
    searchForName: 'Search for Name',
    vm: {
      connectionInfo: 'Connection Info',
      connectionPort: 'Connection Port',
      protocol: 'Protocol',
      username: 'Username',
      password: 'Password',
      lockingState: 'Locking State',
      machineType: 'Machine Type',
      unknown: 'Unknown',
      locked: 'Locked',
      unlocked: 'Unlocked',
      selectVM: 'Select Virtual Machine',
      enterVmNameForSearch: 'Enter virtual machine name for search',
      selectAttachIPv4: 'Select attach IPv4',
      enterIpForSearch: 'Enter ip for search',
      selectDetachIPv4: 'Select detach IPv4',
      detachIpv4Info:
        'The ip address will be separated from this network card.',
      youCannotShrinkAPackage: 'You cannot shrink a package.',
      serverIsDown: 'Your data cannot be viewed because the server is down.',
    },
    cloudNode: {
      nodeType: 'Node Type',
      virtualization: 'Virtualization',
      virtualizationVersion: 'Virtualization Version',
      minCPULimit: 'Min CPU Limit',
      maxCPULimit: 'Max CPU Limit',
      minRAMLimit: 'Min RAM Limit',
      maxRAMLimit: 'Max RAM Limit',
      isPublic: 'Is Public?',
      isEdge: 'Is Edge?',
      startAutoDiscovery: 'Start Auto Discovery',
      setNodePublic: 'Set this node public',
      makePubliclyAvailable: 'Make publicly available',
      changeMaintenanceMode: 'Change Maintenance Mode',
      addServer: 'Add Server',
      addNetworkDevice: 'Add Network Device',
    },
    stash: {
      createArchiveNow: 'Create your archive now',
      createAccount: 'Create your account in 5 minutes and start using it now',
      allFileInfo:
        "Don't let your files get old in your memory<br />STASH it all",
      notCurrentlyStashProduct:
        'You are not currently using our Stash product.',
      ifYouWishStartUsing:
        'If you wish, you can start using Stash immediately.',
      getStartedNow: 'Get Started Now',
      username: 'Username',
      password: 'Password',
      details: 'Details',
      basic: 'Basic',
      deleteYourAccount: 'Delete your account',
      lastUploads: 'Last Uploads',
      name: 'Name',
      dateCreated: 'Date Created',
      lastEdit: 'Last Edit',
      size: 'Size',
      storageUsage: 'Storage Usage',
      storageManagement: 'Storage Management',
      lastActivities: 'Last Activities',
      users: 'Users',
      fullname: 'Full Name',
      status: 'Status',
      active: 'Active',
      inactive: 'Inactive',
      quota: 'Quota',
      actions: 'Actions',
      createStashUser: 'Create Stash User',
      updateStashUser: 'Update Stash User',
      listOfProductAndServices: 'List of Products and Services',
      goToStash: 'Go To Stash',
      wizard: 'Wizard',
      createStash: 'Create Stash',
      stashName: 'Stash Name',
      stashDescription: 'Stash Description',
      stashInformation: 'Stash Information',
      setupYourStashInfo:
        'STASH is your private, organized and secure cloud space where you can store all your files.',
      setupYourStash: 'Setup your Stash',
      userInformation: 'User Information',
      setupYourUser: 'Setup your User',
      setupYourUserInfo:
        'Set the username and password you will use to log in to your STASH domain through the panel.',
      setupPackage: 'Setup Package',
      chooseYourPackage: 'Choose your package and location',
      confirmation: 'Confirmation',
      checkoutYourOrderAndConfirm: 'Checkout your order and confirm',
      createStashInfo:
        'With Stash you can create as many new spaces as you want.',
      pluscloudsLabs:
        'CAREFULLY DEVELOPED<br /><span style="color: #09c4f6;font-size: 30px;">IN PLUSCLOUDS LABORATORIES</span>',
      storeAllFiles:
        'Securely store all files from your mobile device and computer in the Cloud.',
      chooseAnotherUsername:
        'This username is in use. Please choose another one.',
    },
  },
  datacenter: {
    dataCenterNode: 'Datacenter Node',
    nodes: 'Nodes',
  },
  forms: {
    vm: {
      name: 'Virtual Machine Name',
      dcNode: 'Select Datacenter Node',
      vmImage: 'Select Virtual Machine Image',
      catalog: 'Select Product Catalog',
      catalogTitle: 'Product Catalog',
      network: 'Select Network',
      basic: 'Basic Installation',
      expert: 'Expert Installation',
      cpu: 'Select CPU',
      ram: 'Select Memory Size',
      overrideUsernameInfo:
        'Override username does not actually change the username for the administration user of virtual machine. It changes the username value in Leo Database. This information is being used by automation tools running outside of your VM. If this information is wrong then automation tools may not run automated tasks.',
      overridePasswordInfo:
        'Override password does not actually change the password for the administration user of virtual machine. It changes the password value in Leo Database. This information is being used by automation tools running outside of your VM. If this information is wrong then automation tools may not run automated tasks.',
      convertToTemplateInfo:
        'Converting the virtual machine to a template allows you to clone this virtual machine across PlusClouds environments. However some cloud nodes may not support cloning from a template.',
      convertToTemplateInfoFarm:
        '{0} does not support cloning from template. Please consult to support to make this template globally available.',
      basicFormDisableInfo:
        'The datacenter node you selected does not support basic installation. Please prefer expert installation.',
      expertFormDisableInfo:
        'To create virtual machines with expert mode, you need to select a datacenter node from top right. After you select a datacenter node, this section will be enabled.',
      vmHaltedInfoMessage:
        'The server must be down to make resource changes. You can update the source after shutting down the server.',
    },
    vd: {
      cloneFromTemplate: 'Clone From Template',
      storageVolume: 'Storage Volume',
      info: 'You are now cloning the disk of a template. Please make sure that templates do come with a default password; "template1!"<br><br>When you use template disks, you need to <b>reset your password yourself</b> to make sure that you are safe!',
    },
    ansible: {
      info: 'Create a Red Hat® Ansible Playbook so that you can create your own procedures and automation scripts using roles perfected by PlusClouds',
    },
    cloudsNodes: {
      nodeName: 'Cloud Node Name',
      enterDatacenterForSearch: 'Enter datacenter for search',
    },
    streaming: {
      clusterName: 'Cluster name',
      serviceType: 'Service Type',
      description: 'Description',
      incomingRouterIp: 'Incoming Roter IP',
      username: 'Username',
      password: 'Password',
      dcNode: 'Datacenter Node',
      domain: 'Domain',
      streamName: 'Stream Name',
      streamDescription: 'Stream Description',
      streamType: 'Stream Type',
      liveStream: 'Live Stream',
      cluster: 'Cluster',
    },
    ip: {
      selectNetworkCard: 'Select Network Card',
    },
  },
  examples: {
    domain: 'e.g. example.com',
    ip: 'e.g. 10.0.0.0',
    port: 'e.g. 443',
    number: 'e.g. 10',
  },
  dns: {
    infoTitle: 'DNS Service Features',
    alwaysONPluscloudsName: 'Always ON',
    alwaysONPlusclouds:
      "Plusclouds DNS Service, 5'ten fazla kıtada ve 15'ten fazla ülkedeki servis ağımız ile birlikte Global DNS çözümlemesine olanak tanıyarak benzersiz yedeklilik ve %100 uptime sağlar.",
    effectiveSecurityName: 'Effective Security',
    effectiveSecurity:
      'Plusclouds DNS Service, uygulamalarınızın ve web servislerinizin her zaman DNS saldırılarından korunmasını sağlamak için tek tıklamayla DNSSEC hizmeti sunar.',
    highStableName: 'High&Stable Performance',
    highStable:
      "Plusclouds DNS Service, ortalama 50 ms'lik DNS coğrafi arama hızı ve 1 dakikadan daha kısa sürede dünya çapında DNS yayılımı sunan, dünyanın en hızlılarından biridir. Sıfır kesinti süresi ile DNS kayıtlarını yerleştirmeye ve yapılandırmaya yardımcı olur.",
    communityLink:
      'For more information, you can visit our <a target="_blank" href="https://plusclouds.com/community">Community</a> page.',
    alwaysON: 'ALWAYS ON',
    alwaysONContent:
      "Plusclouds DNS Service, 5'ten fazla kıtada ve 15'ten fazla ülkedeki servis ağımız ile birlikte Global DNS çözümlemesine olanak tanıyarak benzersiz yedeklilik ve %100 uptime sağlar.",
    effectiveSecurityTitle: 'EFFECTIVE SECURITY',
    effectiveSecurityContent:
      'Plusclouds DNS Service, uygulamalarınızın ve web servislerinizin her zaman DNS saldırılarından korunmasını sağlamak için tek tıklamayla DNSSEC hizmeti sunar.',
    highStableTitle: 'HIGH&STABLE PERFORMANCE',
    highStableContent1:
      "Plusclouds DNS Service, ortalama 50 ms'lik DNS arama hızı ve 1 dakikadan daha kısa sürede dünya çapında DNS yayılımı sunan, dünyanın en hızlılarından biridir.",
    highStableContent2:
      'Sıfır kesinti süresi ile DNS kayıtlarını yerleştirmeye ve yapılandırmaya yardımcı olur.',
    working: 'Working',
    notWorking: 'Not Working',
    enableDNSService: 'Enable DNS service for this domain',
  },
  popups: {
    detachFromServer: {
      infoText1:
        'When you press ok, your disk will be unmounted from the server if your server is down.',
      infoText2: 'You can then connect your disk to any server you wish.',
      infoText3:
        'Unmounting your disk does not mean that your disk will be erased.',
      infoText4:
        'If you delete your server after removing the disk, your disk will not be erased.',
    },
  },
  productCatalog: {
    totalAmount: 'Total Amount',
    vatIsNotIncluded: 'VAT is not included.',
  },
  verification: {
    info: 'We need some approvals before you can set up a server.',
    verifyEmail: 'Verify your mail address.',
    verifyGsm: 'Verify your GSM.',
    verifyTC: 'Verify your Identity Number.',
    confirmEmailInfoText:
      'Please activate your mail by entering the code we send to your email address.',
    confirmEmailConfirmationCode: "Didn't the confirmation code arrive?",
    tryAgain: 'Try Again',
    confirm: 'Confirm',
    confirmationCode: 'Confirmation code',
    sendConfirmationCode: 'Send confirmation code',
    saveAndSendConfirmationCode: 'Save and send confirmation code',
    pleaseEnterGSMNo: 'Please enter your GSM Number',
    verifyYourIdentityNumberInfoText:
      'Please Confirm your account by entering your Identity number',
    confirmationCodeHasBeenSentMail:
      'Confirmation code has been sent to your email address',
    yourMailConfirmed: 'Your email address has been confirmed.',
    yourMailConfirmError: 'There was a problem verifying your email address.',
    goToLogin: 'Go to login',
    second: 'second',
    beingRedirectedLoginScreen: "You're being redirected to the login screen..",
    timeLeft: 'Time Left',
    fullname: 'Fullname',
    fullnameIsRequired: 'Fullname is required',
    birthDateWithFormat: 'Birth Date (MM/DD/YYYY)',
    birthDateIsRequired: 'Birth date is required',
    birthDateRequiredFormat: 'Enter the date of birth as month/day/year.',
    identityNumber: 'Identity Number',
    identityIsRequired: 'Your ID Number is required',
    identityNumberConfirmed: 'Your identity number has been approved.',
    identityNumberConfirmError:
      'There was a problem confirming your ID number.',
    invalidBirthDate: 'You entered an invalid date in the date of birth field.',
    birthDataUpdateError:
      'There was a problem updating your date of birth. Your transactions cannot be continued.',
    completeTheProcess: 'Complete The Process',
    confirmationCodeHasBeenSentPhone:
      'Confirmation code has been sent to your phone',
    yourPhoneConfirmed: 'Your phone number has been confirmed.',
    yourPhoneConfirmError: 'There was a problem verifying your phone number.',
    selectPhoneCode: 'Select phone code',
    notTurkishCitizen: 'I am not a Turkish Citizen.',
  },
  scheduler: {
    scheduler: 'Scheduler',
    schedulerDetail: 'Scheduler Detail',
    searchForScheduler: 'Search for scheduler',
    createNewScheduler: 'Create new scheduler',
    updateScheduler: 'Update scheduler',
    name: 'Scheduler Name',
    url: 'Url',
    method: 'Method',
    schedule: 'Schedule',
    parameters: 'Parameters',
    headers: 'Headers',
    headersAndParameters: 'Headers & Parameters',
    enabled: {
      true: 'True',
      false: 'False',
    },
    isEnable: 'Is enable?',
    runManually: 'Run Manually',
    setScheduler: 'Set Scheduler',
    manage: 'Manage',
    preview: 'Preview',
    body: 'Body',
    header: 'Header',
    response: 'Response',
    enterVariable: 'Enter variable',
    enterValue: 'Enter value',
    addNewVariable: 'Add new variable',
    clickSubmitToSeeResult: 'Click submit to see the result.',
    cronExpression: 'Cron expression:',
  },
  time: {
    minute: 'Minutes',
    hourly: 'Hourly',
    daily: 'Dayly',
    weekly: 'Weekly',
    weekday: 'Weekday',
    monthly: 'Monthly',
    yearly: 'Yearly',
    '2yearly': '2 Yearly',
    '3yearly': '3 Yearly',
    '4yearly': '4 Yearly',
    '5yearly': '5 Yearly',
    once: 'Once',
    everyMinute: 'Every minute',
    evenMinutes: 'Even minutes',
    oddMinutes: 'Odd minutes',
    every5Minutes: 'Every 5 minutes',
    every15Minutes: 'Every 15 minutes',
    every30Minutes: 'Every 30 minutes',
    everyHour: 'Every hour',
    evenHours: 'Even hour',
    oddHours: 'Odd hours',
    every6Hours: 'Every 6 hours',
    every12Hours: 'Every 12 hours',
    everyDay: 'Every day',
    evenDays: 'Even days',
    oddDays: 'Odd days',
    every5Days: 'Every 5 days',
    every10Days: 'Every 10 days',
    everyHalfMonth: 'Every halt month',
    everyMonth: 'Every month',
    evenMonths: 'Even months',
    oddMonths: 'Odd months',
    every10Months: 'Every 10 months',
    everyHalfYear: 'Every half year',
    everyWeekday: 'Every weekday',
    mondayToFriday: 'Monday - Friday',
    weekendDays: 'Weekend days',
    midnight: 'Midnight',
    noon: 'Noon',
    am: 'am',
    pm: 'pm',
  },
  weekday: {
    0: 'Sunday',
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday',
  },
  month: {
    1: 'January',
    2: 'February',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December',
  },
  shortDay: {
    mon: 'Mon',
    tue: 'Tue',
    wed: 'Wed',
    thu: 'Thu',
    fri: 'Fri',
    sat: 'Sat',
    sun: 'Sun',
  },
  gateways: {
    gateways: 'Gateways',
    gatewaysDetail: 'Gateway Detail',
    createNewGateway: 'Create New Gateway',
    updateGateway: 'Update Gateway',
    searchForGateway: 'Search for gateway',
    publicNetwork: 'Public Network',
    privateNetwork: 'Private Network',
    failedToFetchVMDetail: 'Failed to fetch virtual machine detail.',
    activate: 'Activate',
    vpnPassive: 'VPN Service Passive',
    enableVpnInfo: 'You need to enable VPN service to see this field.',
    natRecordPassive: 'NAT Service Passive',
    enableNatInfo: 'You need to enable NAT Service to see this field.',
    proxyRecordPassive: 'Proxy Service Passive',
    enableProxyInfo: 'You need to enable Proxy Service to see this field.',
    dhcpRecordPassive: 'DHCP Service Passive',
    dhcpRecordActive: 'DHCP Service Active',
    enableDHCPInfo: 'You need to enable DHCP Service to see this field.',
    ntpRecordPassive: 'NTP Service Passive',
    enableNTPInfo: 'You need to enable NTP Service to see this field.',
    loadBalancerRecordPassive: 'Load Balancer Service Passive',
    enableLoadBalancerInfo:
      'You need to enable Load Balancer Service to see this field.',
    vpnRecordPassive: 'VPN Service Passive',
    is_connected: 'Is connected?',
    is_connection_secure: 'Is connection secure?',
    is_usable: 'Is usable?',
    nodes: 'Nodes',
    enterNode: 'Enter Node',
    domainName: 'Domain Name',
    balancingMethod: 'Balancing Method',
    createProxyHostRecord: 'Create Proxy Host Record',
    createLoadBalanceHostRecord: 'Create Load Balance Record',
    createVpnClientRecord: 'Create VPN Client Record',
    pools: 'Pools',
    timezone: 'Timezone',
    ntpService: 'NTP Service',
    enterDomain: 'Enter Domain',
    enableVpnService: 'Enable VPN Service',
    mode: 'Mode',
    isTlsServer: 'Is TLS Server?',
    dev: 'Dev',
    keepAlive: 'Keep Alive',
    deleteVpnConfig: 'Delete VPN Config',
  },
  password: {
    score: 'Score',
    fair: 'Fair',
    good: 'Good',
    veryStrong: 'Very Strong',
    eightCharactersMinimum: '8 charactes minimum',
    oneUpper: 'One upper',
    oneLower: 'One lower',
    oneNumber: 'One number',
    oneSpecialCharacter: 'One special character',
  },
  communication: {
    communication: 'Communication',
    communicationChannels: 'Communication Channels',
    newsChannels: 'News Channels',
    newsListInfo: 'The news channels you are registered with are listed below.',
    emailRecordsCannotBeDeleted: 'Email records cannot be deleted.',
    createNewChannel: 'New Channel',
    form: {
      channelType: 'Channel Type',
      webhookUrl: 'Webhook Url',
      passcode: 'Code',
      codeInfo:
        'To verify the webhook address, you need to enter the code you received below.',
    },
  },
  list: {
    noRecordInfoLine1: "You don't have any record added yet.",
    noRecordInfoLine2: 'Create your record and start using it now!',
    noRecordInfoLine1ForSearch:
      "We couldn't find any records matching your search.",
    addNew: 'Add New',
    clearFilters: 'Clear Filters',
  },
  registry: {
    plusCloudsRegistry: 'PlusClouds Registry',
    createNewRepository: 'Create New Repository',
    updateRepository: 'Update Repository',
    lastHash: 'Last Hash',
    imageList: 'Image List',
  },
  plusCloudsCs: {
    advertiseAddr: 'Advertise Address',
    listenAddr: 'Listen Address',
    managerCount: 'Manager Count',
    networkCount: 'Network Count',
    runningReplicaCount: 'Running Replica Count',
    workerCount: 'Worker Count',
    createServiceManagement: 'Create Service Management',
  },
  giftcode: {
    giftcode: 'Gift Code',
    useGiftCode: 'Use Gift Code',
    giftcodes: 'Gift Codes',
    addnewcode: 'Add New Code',
    newCodeInfo:
      'By entering your discount code, you can benefit from special discounts.',
    useCode: 'Use Code',
    code: 'Code',
    discount: 'Discount',
    discountProductInformation: 'Discount Product Information',
    notFound: 'Cannot find a gift code with that code.',
    codeUsedBefore: 'The entered code has already been used.',
    checkCode: 'Check code',
    product: 'Product',
    isUsed: 'Is Used?',
    cancelCode: 'Cancel code',
  },
  iam: {
    plusCloudsIAM: 'IAM',
    plusCloudsIAMDetail: 'IAM Detail',
    createNewIAMService: 'Create New IAM Service',
    updateIAMService: 'Update IAM Service',
    ldap_server_name: 'LDAP Server Name',
    ldap_server_name_placeholder: 'LDAP Example',
    ldap_server_url: 'LDAP Server Url',
    ldap_server_url_placeholder: '10.100.10.1',
    ldap_server_port: 'LDAP Server Port',
    ldap_server_port_placeholder: '389',
    ldap_base_dn: 'LDAP Base DN',
    ldap_base_dn_placeholder: 'dc=plusclouds,dc=com',
    ldap_bind_username: 'LDAP Username',
    ldap_bind_username_placeholder: 'cn=admin,dc=plusclouds,dc=com',
    ldap_bind_password: 'LDAP Password',
    default_filter: 'Default Filter',
    default_filter_placeholder: '(objectclass=*)',
    default_memberof: 'Default Member of',
    default_group: 'Default Group',
    default_userid_field: 'Default UserId Field',
    default_userid_field_placeholder: 'uid',
    default_password_field: 'Default Password Field',
    default_email_field: 'Default Email Field',
    default_alias_field: 'Default Alias Field',
    default_alias_field_placeholder: 'cn',
    default_first_name_field: 'Default First Name Field',
    default_last_name_field: 'Default Last Name Field',
    default_last_name_field_placeholder: 'sn',
    people: 'People',
    groups: 'Groups',
    createNewPerson: 'Create New Person',
    updatePerson: 'Update Person',
    createNewGroup: 'Create New Group',
    updateGroup: 'Update Group',
    givenname: 'Given name',
    cn: 'Name.Surname (cn)',
    sn: 'Surname (sn)',
    uid: 'User Name (uid)',
    homedirectory: 'Home Directory',
    loginshell: 'Login Shell',
  },
  account: {
    overview: 'Overview',
    settings: 'Settings',
    informationVerification: 'Information Verification',
    emailNotValidated: 'Email not validated',
    phoneNotValidated: 'Phone not validated',
    ninNotValidated: 'Nin not validated',
    emailValidated: 'Email validated',
    phoneValidated: 'Phone validated',
    ninValidated: 'Nin validated',
    memberSince: 'Member since',
    fullName: 'Full Name',
    about: 'About',
    gender: 'Gender',
    birthday: 'Birthday',
    phone: 'Phone',
    country: 'Country',
    accountType: 'Account Type',
    roles: 'Roles',
    profileDetails: 'Profile Details',
    contactMe: 'Contact Me',
    customerRepresentative: 'Your Customer Representative',
    customerRepresentativeName: 'Dilara Ödemiş',
    contactSalesConsultant: 'Contact Sales Consultant',
    salesConsultant: 'Sales Consultant',
    salesConsultantMessage:
      'Could you give us information about the subject you want to reach us so that we can serve you better?',
    from: 'From',
    to: 'To',
    updatePassword: 'Update Password',
    updateEmail: 'Update Email',
    updatePhone: 'Update Phone',
    updateCurrency: 'Update Currency',
    updateCurrencyTitle: 'Currency change request',
    updateCurrencyDescription:
      'Dear official, I want to change the main currency I use in the system as follows. I would be glad if you could help.',
    phoneCode: 'Phone Code',
    support: 'Support',
    payment: 'Payment',
    addresses: 'Addresses',
    isInvoiceAddress: 'Is Invoice Address?',
    addressName: 'Address Name',
    address: 'Address',
    createNewAddress: 'Create New Address',
    updateAddress: 'Update Address',
    state: 'State',
    postCode: 'Post Code',
    addressLine1: 'Adress Line 1',
    addressLine2: 'Adress Line 2',
    searchSupportTicket: 'Search support ticket',
    newSupportTicket: 'New Ticket',
    ticketNumber: 'Ticket Number',
    searchForTicketNumber: 'Search for Ticket Number',
    newTicketAlert: 'New tickets available!',
    subject: 'Subject',
    message: 'Message',
    closeTicket: 'Close Ticket',
    writeSomething: 'Write something',
    writeReplyOrDragFilesHere: 'Write reply or drag files here',
  },
  accountType: {
    Individual: 'Personal Account',
    Corporate: 'Corporate Account',
    Association: 'Association Account',
    K12: 'School or College',
    University: 'University',
    NPO: 'Non-profit Account',
    NGO: 'Non-government Account',
    Team: 'Team Account',
  },
  gender: {
    male: 'Male',
    female: 'Female',
  },
  errors: {
    notEmpty: 'This field cannot be empty.',
    minLenght: 'Must be a minimum of {0} characters.',
    maxLenght: 'Must be a maximum of {0} characters.',
  },
  alert: {
    moduleUnderMaintenance:
      'This module is currently under maintenance. You can continue to use it after the maintenance is finished.',
    useSupport:
      'In order to better serve you, monitor service continuity and communicate technical issues directly to our team, please submit a support request in the <a href="/support" class="text-warning">support area</a> on the left side.',
  },
  token: {
    personalAccessTokens: 'Personal Access Tokens',
    personalAccessToken: 'Personal Access Token',
    expireDate: 'Expire Date',
    recordNo: 'Record No',
    addNewToken: 'Add New Token',
    create: 'Create',
    tokenSuccessResult:
      'The token information you can use in your transactions is shared below. Please save the information.',
  },
}
